import { ViewModelCritica } from './../shared/models/viewModelCritica';
import { Component, OnInit, ViewChild} from '@angular/core';
import { Router } from "@angular/router";
import { RegistroCobrancaService } from './../shared/services/registroCobranca.service';
import { MatSnackBar, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ViewModelEnviaCobranca } from '../shared/models/enviaCobranca.model';


export interface PeriodicElement {
  nome: string;
  cpf: number;
  mensagemErro: string;
}
const ELEMENT_DATA: PeriodicElement[] = [


  ];



  
@Component({
  selector: 'app-critica-registro-boleto',
  templateUrl: './critica-registro-boleto.component.html',
  styleUrls: ['./critica-registro-boleto.component.scss']
})


export class CriticaRegistroBoletoComponent implements OnInit {
    displayedColumns: string[] = ['cpf', 'nome',  'mensagemErro'];
    dataSource = new MatTableDataSource<any>();
    pageIndex = "";
    pageSize = "";
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    viewModelCritica: ViewModelCritica[] = [];
    loading = false;
    dataFormatada: string;
    dataVencimento: Date;
    inputCpf:boolean = false;
    cpf:string;
    viewModelEnviaCobranca: ViewModelEnviaCobranca = new ViewModelEnviaCobranca();   
    today: Date = new Date();
    currentYear: number = this.today.getFullYear();
    currentMonth: number = this.today.getMonth();
    currentDay: number = this.today.getDate();
    minDate: Object = new Date(
      this.currentYear,
      this.currentMonth,
      this.currentDay
    );


    
  constructor(
    private readonly router: Router,
    private _snackBar: MatSnackBar,
    private readonly registroCobrancaService: RegistroCobrancaService,
   
  ) {  
  
  }

  ngOnInit() {
  }
  
  resultadoCobranca(){
    this.loading = true;
    this.formataDataAtual();
   
    if (this.dataVencimento == undefined) {
        this._snackBar.open('Informe o parâmetro data para realizar a busca!"', 'X', {
            duration: 30000,
            panelClass: ['red-snackbar']
        })
        this.loading = false;
    }
   
    this.registroCobrancaService.getCriticaRegistroBoleto(this.dataFormatada).subscribe(retorno => {
        if(retorno)
        {
            this.viewModelCritica = retorno;
            this.dataSource = new MatTableDataSource<ViewModelCritica>(retorno)
            this.dataSource.paginator = this.paginator;
            this.inputCpf = true;
            this.loading = false;
            console.log('aqui', retorno);
           
        }
    }, error => {
        this.loading = false;
        this._snackBar.open('Nao foi possivel trazer dados para a data selecionada', 'X', {
            duration: 30000,
            panelClass: ['red-snackbar']
        })
    });
   
}
clear() {
    this.inputCpf = false;
    this.cpf =undefined;
    this.dataVencimento = undefined;
    this.dataSource.data = [];
}
applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  formataDataAtual() {
    var dia = this.dataVencimento.getDate();
    var mes = this.dataVencimento.getMonth() + 1;
    var ano = this.dataVencimento.getFullYear();
    this.dataFormatada = ano + "-" + (mes < 10 ? ('0' + mes) : mes) + "-" + (dia < 10 ? ('0' + dia) : dia);

  }

}
